module.exports = __webpack_public_path__ + "static/media/login.a13fc8fd.jpg";